// extracted by mini-css-extract-plugin
module.exports = {"link":"SlideUpButton_link__NWiK5","linkText":"SlideUpButton_linkText__1F1IQ"};